/**
 * Visszaadja a dátumból az évet.
 * @param {Date} [date] - A megadott dátum.
 * @example
 * ```js
 * getYear(new Date('2021-01-01')) // 2021
 * getYear() // Az aktuális év.
 * ```
 * @returns {number} Az adott dátum éve.
 */
module.exports.getYear = function getYear (date = new Date()) {
  return date.getFullYear()
}
